import { requestStatus } from "../../../../constants";

export const requestStatusTypes = {
  ...requestStatus,
  waiting: "Waiting",
  inProgressDemand: "InProgressDemand",
  acceptanceDemand: "AcceptanceDemand",
  completedDemand: "CompletedDemand",
  submittedAssignee: "SubmittedAssignee",
};
